<template>
  <el-dialog title="订单分成" :visible.sync="dialogTableVisible" width="1200px">
    <el-table :data="list">
      <el-table-column prop="username" label="分成人"></el-table-column>
      <el-table-column label="分成类别">
        <template slot-scope="scope">
          {{ divvyCategory[scope.row.divideType] }}
        </template>

      </el-table-column>
      <el-table-column prop="divideRate" label="分成比例（%）"></el-table-column>
      <el-table-column prop="sum" label="分成金额（元）"></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { orderDivvyListApi } from '@/api/order'
import { packageOrderDivvyListApi } from '@/api/package-order'

export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogTableVisible: false,
      defaultParams: {},
      list: [],
      divvyCategory: {
        1: '合伙人',
        2: '商家',
        3: '代理商',
      },
    }
  },
  methods: {
    open(row) {
      this.code = row.number
      if (this.type === 'common-order') this.getOrderDivvyList()
      if (this.type === 'package-order') this.getPackageOrderDivvyList()
      this.dialogTableVisible = true
    },

    // 普通订单分成列表
    getOrderDivvyList() {
      orderDivvyListApi(this.code).then((res) => {
        this.list = res.data.resList
      })
    },

    // 套餐订单分成列表
    getPackageOrderDivvyList() {
      packageOrderDivvyListApi(this.code).then((res) => {
        this.list = res.data.resList
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
